<script>

// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
// https://codechips.me/svelte-cross-component-communication/
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=


//export let loggedIn = false;

import { onMount, onDestroy } from 'svelte';

import { createEventDispatcher } from 'svelte';

import {link} from 'svelte-spa-router'
import active from 'svelte-spa-router/active'

import { account_service       , account_service_context_key        } from './_services/account.js';
import { loginWithEmailPassword, refreshJWT, loggedIn, logOut       } from './_services/accountsession.js';
import { cookiejar_service     , cookiejar_service_context_key      } from './_services/cookiejar.js';
	

const dispatch = createEventDispatcher();
	
	let user_credentials = {
		uname: 'ada@lovelace.com',
		psw: 'secret'
	};
	
	
onMount(async () => {
 
		const theJWTCookie_set = $cookiejar_service.getCookie('JWT_set');
		if (theJWTCookie_set) {
			console.log('theJWTCookie_ is set')
		
		} 
		else {
			console.log('theJWTCookie_ not set')
		} 

		// always try to refresh the JWT
		await refreshJWT(
				/*success_callback*/ function () {
					console.log('await $accountsession_service.refreshJWT::hooraay for the refresh');
				   
				   // bubble up the token refresh
					dispatch('sessionEvent', {
							'loggedIn': $loggedIn
						});
				} ,
				/*error_callback*/ function () {
					console.log('await $accountsession_service.refreshJWT::oooow no refresh');
				   // bubble up the token refresh
					dispatch('sessionEvent', {
							'loggedIn': $loggedIn
						});
				});

});



    function handleSubmit(event) {
//        console.log(event);
//        console.log(user_credentials);

        loginWithEmailPassword(user_credentials.uname, user_credentials.psw,
        		    function (res) { 
console.log(res);
        					   if (  res  ) {
        					   /*on-success handler*/
							   alert('logged in');

//							   // set window url by pushing new location
//								push('/applist/'); 

//							   alert('logged in - set');

        					   }
        					   else {
        						/*on-error handler*/
							   alert('function (res) :: error on login');
        					   }
        				}, 
        			   function (err) {
        						/*on-error handler*/
							   alert('function (err) :: error on login');
                  }
        		) ;

							   // bubble up the login state
								dispatch('sessionEvent', {
										'loggedIn': $loggedIn
									});
    }

    function handleLogOut() {
       logOut() ;
	   // bubble up the logout event
		dispatch('sessionEvent', {
						'loggedIn': $loggedIn
					});
    }

	onDestroy(() => { 
	});


</script>

<style>

#navigation {
  visibility: visible;
  display: flex;
  width: 100%;
  height: 40px;
  margin: 0px;
  top: 0px;
  left: 0px;
  background-color: #231105;
box-shadow: 0px 0px 3px 0px black;
  padding: 5px;
  position: fixed;
  right: 0px;
  align-items: center;
  align-self: auto;
  justify-content: flex-start;
  z-index: 999;
}

.navigation-item {
  background-color: #b98b67;
  width: 110px;
  padding: 3px;
  margin: 2px;
  font-family: "sans-serif";
  text-align: center;
  border-radius: 2px;
  border: 0px solid black;
}


.navigation-spacer {
  width: 60%;
  padding: 3px;
  margin: 2px;
}

	:global(a.active) {
	    color: rgb(233,218,197);
	    text-decoration: underline;
       font-weight: bold;
	}
	

    /*set the Modal background*/
    .modal {
        display: none;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgb(0, 0, 0);
        background-color: rgba(0, 0, 0, 0.4);
        padding-top: 60px;
        z-index: 9999;
    }
      
    /*style the model content box*/
    .modal-content {
        background-color: #fefefe;
        margin: 5% auto 15% auto;
        border: 1px solid #888;
        width: 40%;
    }

    .container-button {
        background-color:#f1f1f1;
    }

</style>

<div id="navigation">
	<span id="navigation-home" class="navigation-item">    <a href="/home"       use:link use:active={{path: '/home',       className: 'active'}}>Home</a></span>
	<span id="navigation-gallery" class="navigation-item"> <a href="/gallery/"   use:link use:active={{path: '/gallery/*',  className: 'active'}}>Gallery</a></span>
	<span id="navigation-about" class="navigation-item">   <a href="/about"      use:link use:active={{path: '/about',      className: 'active'}}>About</a></span>
	<span id="navigation-apps" class="navigation-item">    <a href="/applist/"   use:link use:active={{path: '/applist/*',  className: 'active'}}>Apps</a></span>

   <span id="navigation-spacer" class="navigation-spacer"> &nbsp;</span> 

	<span id="navigation-login" class="navigation-item">
	{#if $loggedIn}
		<a  on:click={handleLogOut}>Log out</a>
	{:else}
		<a  onclick="document.getElementById('modal-login').style.display='block'">Login</a>
	{/if}
	</span>
	
</div>


	{#if $loggedIn}
	    &nbsp;
	{:else}
      <div id="modal-login" class="modal">
        <!-- -------------------------------------------------------------------------
          -- https://www.geeksforgeeks.org/html-responsive-modal-login-form/     
          -- -------------------------------------------------------------------------  -->
        <form class="modal-content" on:submit|preventDefault="{handleSubmit}">
          <div class="container-header"> 
              <!--img src="img_avatar2.png" alt="Avatar" class="avatar"-->
          </div>
          <div class="container-content"> 
            <label for="uname"><b>Username</b></label>
            <input id="myInputUname" name="uname" bind:value="{user_credentials.uname}" placeholder="Enter Username" required="" type="text"> 
             <br/>
            <label for="psw"><b>Password</b></label>
            <input id="myInputPsw" name="psw" bind:value="{user_credentials.psw}" placeholder="Enter Password" required="" type="password">
             <br/>
             <span> Forgot <a href="#" onclick="document.getElementById('modal-login').style.display='none'">password?</a></span>
             <br/>
          </div>
          <div class="container-button" > 
             <button type="submit" id="loginBtn">Login</button> 
             <button type="button" id="cancelBtn" onclick="document.getElementById('modal-login').style.display='none'">Cancel</button> 
             <span> <input checked="unchecked" name="remember" type="checkbox"> Remember me </span> 
             <br/>
          </div>
        </form>
        <script>
        var modal = document.getElementById('modal-login');
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }
    </script> 
    </div>
	{/if}

